<span (click)="onClick($event)" [ngClass]="{'cursorPointer': isCursor ,'text-red':isNegative() || isNegativeFormatted(value) ,'text-primary':(value >= 0)}" class="px-2" >{{value < 0 ? '(-) '+ removeNegativeSign(value) : isPercent ? value+'%' : value}}</span>

